export const loginPageImageUrl = [
  "https://rulezero.imgix.net/rulezerowebsite/Group%2033677.png",
  "https://rulezero.imgix.net/rulezerowebsite/hissa.png",
  "https://rulezero.imgix.net/rulezerowebsite/captable.png",
];
